import Button from "@material-ui/core/Button";
import { Card, } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { errorSnackbar, successSnackbar, } from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import MTextField from "../../components/MTextField";
import { PATH } from "../../constants/appConstants";
import { isValidEmail } from "../../helpers/appFieldValidation";
import { getCopy } from "../../helpers/utils.helper";
import "./forgotPassword.scss";


export default function ForgotPassword(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [otpSent, setOtpSent] = useState(false);
    const [user, setUser] = useState({});
    const [userData, setUserData] = useState({});

    const handleChange = (event) => {
        const updatedUser = getCopy(user);
        updatedUser[event.target.name] = event.target.value;
        setUser(updatedUser);
    };

    const requestPasswordChange = () => {
        AjaxHelper.postApi(navigate, Endpoint.REQUEST_PASSWORD_CHANGE, {
            userCode: user.userCode
        })
            .then((response) => {
                if (response.data.status === Status.API_SUCCESS) {
                    dispatch(successSnackbar("OTP sent successfully."));
                    setOtpSent(true);
                    setUserData(response.data.data);
                } else {
                    dispatch(errorSnackbar("Unable to send otp."));
                }
            })
            .catch((err) => {
                dispatch(errorSnackbar("Unable to send otp."));
            });
    }

    const resendOTP = () => {
        AjaxHelper.postApi(navigate, Endpoint.RESEND_OTP, {
            userCode: user.userCode
        })
            .then((response) => {
                if (response.data.status === Status.API_SUCCESS) {
                    dispatch(successSnackbar("OTP sent successfully."));
                    setOtpSent(true);
                    setUserData(response.data.data);
                } else {
                    dispatch(errorSnackbar("Unable to send otp."));
                }
            })
            .catch((err) => {
                dispatch(errorSnackbar("Unable to send otp."));
            });
    }

    const updatePasswordWithOTP = () => {
        AjaxHelper.postApi(navigate, Endpoint.UPDATE_USER_PASSWORD_OTP, user)
            .then((response) => {
                if (response.data.status === Status.API_SUCCESS) {
                    dispatch(successSnackbar("Account's password is updated."));
                    navigate(PATH.LOGIN_SCREEN, {replace: true})
                } else {
                    dispatch(errorSnackbar("Unable to update account's password."));
                }
            })
            .catch((err) => {
                dispatch(errorSnackbar("Unable to update account's password."));
            });
    }


    return (
        <div className="component-verify-email d-flex justify-content-start flex-column">
            <div className="brand-bg-inverse-color mb-3 col-12">
                <div className="container">
                    <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
                        <Link to={"/"} className="navbar-brand">
                            <img
                                src={require("../../assets/logo.png")}
                                alt=""
                                width={"140px"}
                            />
                        </Link>
                    </nav>
                </div>
            </div>
            <div className="inner-div">
                <Card variant={"outlined"} className="register-card my-5 col-md-8">
                    <div className="card-header">Forgot password</div>
                    <div className="card-body">
                        <div className="form">
                            <MTextField
                                id={"userCode"}
                                name={"userCode"}
                                className="col-12"
                                required={true}
                                label={`Memon ID`}
                                value={user["userCode"]}
                                onChange={handleChange}
                                disabled={false}
                                error={false}
                                placeholder={"Enter your Memon ID."}
                            />
                            {
                                otpSent ? <>
                                    <MTextField
                                        id={"email_otp"}
                                        name={"otp"}
                                        className="col-12"
                                        required={true}
                                        label={`OTP`}
                                        value={user["otp"]}
                                        onChange={handleChange}
                                        disabled={false}
                                        error={false}
                                        placeholder={"Enter OTP."}
                                        helperText={isValidEmail(userData.otpSendTo) ? `OTP has been sent to your registered email ${userData.otpSendTo}` : `OTP has been sent to your registered mobile number ${userData.otpSendTo}`}
                                    />

                                    <MTextField
                                        id={"new_password"}
                                        name={"password"}
                                        className="col-12"
                                        required={true}
                                        label={`New password`}
                                        value={user["password"]}
                                        onChange={handleChange}
                                        disabled={false}
                                        error={false}
                                        placeholder={"Enter new password."}
                                    />

                                </> : null
                            }

                        </div>
                    </div>
                    <div className="card-footer">
                        {
                            otpSent ? <>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={"button2"}
                                    onClick={() => {
                                        resendOTP();
                                    }}
                                >
                                    Resend OTP
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={"button"}
                                    onClick={() => {
                                        updatePasswordWithOTP();
                                    }}
                                >
                                    Update
                                </Button>
                            </> : <Button
                                variant="contained"
                                color="primary"
                                className={"button"}
                                onClick={() => {
                                    requestPasswordChange();
                                }}
                            >
                                Send OTP
                            </Button>
                        }

                    </div>
                </Card>
            </div>
        </div>
    );
}
